module.exports = __webpack_public_path__ + "img/patent-3.10dc1969.png";